import { render, staticRenderFns } from "./OpenPoints.vue?vue&type=template&id=4ddf66bb&scoped=true"
import script from "./OpenPoints.vue?vue&type=script&lang=js"
export * from "./OpenPoints.vue?vue&type=script&lang=js"
import style0 from "./OpenPoints.vue?vue&type=style&index=0&id=4ddf66bb&prod&scoped=true&lang=css"
import style1 from "./OpenPoints.vue?vue&type=style&index=1&id=4ddf66bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf66bb",
  null
  
)

export default component.exports